import { SearchFilter } from '../../interfaces/filters/search.filter';
import { PaginationFilter } from '../../interfaces/filters/pagination.filter';
import { BaseEventInstanceDto } from '../dto/event.dto';
import { Transform } from 'class-transformer';
import { arrayOrStringToArray, jsonStringToObject, stringToBooleanNullable, stringToInt } from '../../types-transformers';
import { OrderFilter } from '../../interfaces/filters/order.filter';
import { TrackingLinkDto } from '../dto';
import { OrderParamPair } from '../../interfaces/filters/order-param-pair';

export class TrackingLinksFilter implements SearchFilter, PaginationFilter, OrderFilter<TrackingLinkDto> {
	@Transform(arrayOrStringToArray)
	ids?: string[];

	@Transform(arrayOrStringToArray)
	communityIds?: string[];

	@Transform(jsonStringToObject)
	events?: BaseEventInstanceDto[];

	@Transform(arrayOrStringToArray)
	referralCodes?: string[];

	@Transform(arrayOrStringToArray)
	discountBaseIds?: string[];

	@Transform(stringToBooleanNullable)
	withDeleted?: boolean;

	@Transform(stringToBooleanNullable)
	extendWithDiscounts?: boolean;

	@Transform(stringToBooleanNullable)
	calculateStatistics?: boolean;

	search?: string;

	searchThreshold?: number;

	@Transform(stringToInt)
	page?: number | null;

	@Transform(stringToInt)
	pageSize?: number | null;

	@Transform(jsonStringToObject)
	public orderedBy?: OrderParamPair<TrackingLinkDto>[] | null;
}
